export default function NotFoundPage() {
  return null;
}
